<template>
  <BaseForm
    :title="formTitle"
    :formData="customerBagPitData"
    :fields="fields"
    :submitUrl="submitUrl"
    :method="method"
    @form-success="handleSuccess"
    @form-error="handleError"
  />
</template>

<script>
import BaseForm from './BaseForm.vue';
import axios from 'axios';

export default {
  components: {
    BaseForm
  },
  props: {
    customerBagPitId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      customerBagPitData: {
        customer_id: '',
        name: '',
        bag_pit_type_id: ''
      },
      fields: [
        { model: 'customer_id', label: 'Customer', required: true, type: 'select', optionsUrl: '/api/v1/customer/customers/', labelField: 'name' },
        { model: 'name', label: 'Name', required: true, type: 'text' },
        { model: 'bag_pit_type_id', label: 'Bag Pit Type', type: 'select', optionsUrl: '/api/v1/bag_pit_type/bag_pit_types/', labelField: 'name' }
      ]
    };
  },
  computed: {
    formTitle() {
      return this.customerBagPitId ? `Edit Customer Bag Pit` : 'Add Customer Bag Pit';
    },
    submitUrl() {
      return this.customerBagPitId ? `/api/v1/customer_bag_pit/customer_bag_pits/${this.customerBagPitId}/` : '/api/v1/customer_bag_pit/customer_bag_pits/';
    },
    method() {
      return this.customerBagPitId ? 'put' : 'post';
    }
  },
  mounted() {
    if (this.customerBagPitId) {
      this.loadCustomerBagPitData();
    }
  },
  methods: {
    loadCustomerBagPitData() {
      axios.get(`/api/v1/customer_bag_pit/customer_bag_pits/${this.customerBagPitId}/`).then(response => {
        this.customerBagPitData = response.data;
      }).catch(console.error);
    },
    handleSuccess() {
      this.$q.notify({
        color: 'green',
        position: 'top',
        message: 'Customer Bag Pit saved successfully!',
        icon: 'check_circle',
        timeout: 3000
      });
    },
    handleError(error) {
      console.error(error);
      this.$q.notify({
        color: 'red',
        position: 'top',
        message: 'There was a problem saving the Customer Bag Pit!',
        icon: 'check_circle',
        timeout: 3000
      });
    }
  }
};
</script>
